import { useEffect, useMemo } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import WorkExplorer from "@/components/feature/WorkExplorer";
import { works } from "@/mocks/works";
import { getCategoryById, getWorksByCategory, getHotTags } from "@/utils/gallery";

export default function ListPage() {
  const { categoryId = "" } = useParams();
  const [searchParams] = useSearchParams();
  const tag = searchParams.get("tag") || "";
  const category = categoryId ? getCategoryById(categoryId) : undefined;

  const heading = tag ? `标签：${tag}` : category ? category.name : "全部作品";

  const baseWorks = useMemo(() => {
    if (tag) {
      const lower = tag.toLowerCase();
      return works.filter(
        (work) =>
          work.tags.some((item) => item.toLowerCase().includes(lower)) ||
          work.style.toLowerCase().includes(lower) ||
          work.scene.toLowerCase().includes(lower) ||
          work.model.toLowerCase().includes(lower)
      );
    }
    if (category) return getWorksByCategory(category.id);
    return works;
  }, [tag, category]);

  useEffect(() => {
    document.title = `${heading} - 国模白露写真作品集`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        `${heading}作品列表，浏览国模白露收录的模特写真摄影作品，支持风格、场景、模特与年份多维筛选。`
      );
    }
  }, [heading]);

  return (
    <div className="px-4 pb-20 pt-24 md:px-8 md:pb-28 md:pt-28">
      <div className="mb-6">
        <Breadcrumb
          items={[
            { label: "作品图片" },
            ...(category ? [{ label: category.name, to: `/category/${category.id}` }] : []),
            { label: tag ? `标签：${tag}` : category ? category.name : "全部作品" },
          ]}
        />
      </div>

      <div className="mb-8">
        <h1 className="text-2xl font-bold text-foreground-950 md:text-3xl">{heading} 作品列表</h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
          通过左侧筛选栏组合风格、场景、模特与年份条件，快速定位感兴趣的写真作品。点击任意作品卡片即可进入详情页欣赏大图。
        </p>
      </div>

      {tag && (
        <div className="mb-6 flex flex-wrap items-center gap-2">
          <span className="text-sm text-foreground-500">热门标签：</span>
          {getHotTags().map((item) => (
            <Link
              key={item}
              to={`/list/fashion?tag=${encodeURIComponent(item)}`}
              className={`whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors ${
                item === tag
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600"
              }`}
            >
              {item}
            </Link>
          ))}
        </div>
      )}

      <WorkExplorer baseWorks={baseWorks} resetKey={`${categoryId}-${tag}`} />
    </div>
  );
}